import { RestResource } from "./common"
import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"
import type { PaginationParams } from "./request"

export enum DIGITAL_ASSET_CUSTOMER_ADDRESS_STATUSES {
  REJECTED = "Rejected",
  REMOVED = "Removed",
  REVIEWED = "Reviewed",
  NEEDS_MANUAL_REVIEW = "Needs Manual Review",
  PENDING_REVIEW = "Pending Review",
}

export interface DigitalAssetCustomerAddressParams extends PaginationParams {
  depositsBlocked?: boolean
  status?: DIGITAL_ASSET_CUSTOMER_ADDRESS_STATUSES
  externalAccountLinkedOnly?: boolean
  withdrawalsBlocked?: boolean
}

const PENDING_STATUSES = [
  DIGITAL_ASSET_CUSTOMER_ADDRESS_STATUSES.PENDING_REVIEW,
  DIGITAL_ASSET_CUSTOMER_ADDRESS_STATUSES.NEEDS_MANUAL_REVIEW,
]
export class DigitalAssetCustomerAddress extends RestResource {
  address = ""
  asset = ""
  memo: string | undefined
  name = ""
  accountNumber = ""
  depositsBlocked = true
  status = DIGITAL_ASSET_CUSTOMER_ADDRESS_STATUSES.PENDING_REVIEW
  withdrawalsBlocked = true

  get isPending() {
    return PENDING_STATUSES.includes(this.status)
  }

  get isRejected() {
    return this.status === DIGITAL_ASSET_CUSTOMER_ADDRESS_STATUSES.REJECTED
  }
}

export const DIGITAL_ASSET_CUSTOMER_ADDRESS_DESER: SchemaDeSer<DigitalAssetCustomerAddress> =
  new SchemaDeSerBuilder(DigitalAssetCustomerAddress)
    .ofString("accountNumber")
    .ofString("id")
    .ofString("address")
    .ofString("asset")
    .ofBoolean("depositsBlocked")
    .ofString("memo")
    .ofString("name")
    .ofString("status")
    .ofBoolean("withdrawalsBlocked")
    .toDeSer()
